/**
 * Call IT Dev - Brand Configuration
 * 
 * Brand Identity: Premium Tech Agency with Human Warmth
 * Tagline: "Where Human Expertise Meets Digital Innovation"
 * 
 * Color Philosophy:
 * - Slate: Trust, professionalism, reliability
 * - Teal: Technology, innovation, growth
 * - Coral: Energy, warmth, action
 */

export const BRAND = {
  // Core brand identity
  name: 'Call IT Dev',
  shortName: 'CiD',
  tagline: 'Where Human Expertise Meets Digital Innovation',
  taglineFr: 'L\'Expertise Humaine au Service de l\'Innovation Digitale',
  
  // Domain & URLs
  domain: 'callitdev.com',
  url: 'https://callitdev.com',
  
  // Contact information
  email: {
    contact: 'contact@callitdev.com',
    sales: 'sales@callitdev.com',
    support: 'support@callitdev.com',
    press: 'press@callitdev.com',
    careers: 'careers@callitdev.com',
    privacy: 'privacy@callitdev.com',
    uae: 'contact@ubtis.com',
  },
  
  phone: {
    main: '+212 5 37 37 37 77',
    support: '+212 6 58 38 03 81',
    uae: '+971 5 58 17 05 08',
    whatsapp: '+212658380381',
  },
  
  // Social media
  social: {
    linkedin: 'https://linkedin.com/company/callitdev',
    twitter: 'https://twitter.com/callitdev',
    facebook: 'https://facebook.com/callitdev',
    instagram: 'https://instagram.com/callitdev',
    github: 'https://github.com/callitdev',
  },
  
  // Legal
  copyright: `© ${new Date().getFullYear()} CALL IT DEV. All rights reserved.`,
  copyrightYear: new Date().getFullYear(),
  
  // Locations
  locations: {
    headquarters: {
      city: 'Casablanca',
      country: 'Morocco',
      timezone: 'GMT+1',
      address: 'Technopark, Route de Nouasseur, Casablanca 20000, Morocco',
    },
    europe: {
      city: 'Madrid',
      country: 'Spain',
      address: 'Business Center, Calle de la Princesa, Madrid 28008, Spain',
    },
    mena: {
      city: 'Dubai',
      country: 'UAE',
      address: 'Business Bay, Dubai, UAE',
    },
  },
  
  // Brand Colors (for external use, JS values)
  colors: {
    teal: '#12b0a0',
    coral: '#e8623e',
    slate: '#1e2a3b',
    gold: '#f5a623',
  },
  
  // Products
  products: {
    neuralAgent: 'Neural Agent',
    quickStart: 'QuickStart',
    academy: 'Call IT Dev Academy',
  },
  
  // SEO
  seo: {
    title: 'Call IT Dev | BPO & Digital Studio — Casablanca, Madrid & Dubai',
    titleTemplate: '%s | Call IT Dev',
    description: 'Premium BPO services and Digital Studio solutions. 24/7 multilingual customer experience teams and cutting-edge software development from Casablanca (Morocco), Madrid (Spain) & Dubai (UAE).',
    keywords: [
      'call center outsourcing',
      'BPO services',
      'customer support Morocco',
      'software development agency',
      'multilingual support',
      'digital transformation',
      'Call IT Dev',
    ],
  },
} as const;

// Helper function to get brand-related text
export function getBrandText(key: keyof typeof BRAND): string {
  return String(BRAND[key]);
}

// Export type for TypeScript usage
export type BrandConfig = typeof BRAND;

export default BRAND;
